<template>
  <div class="layout">
    <el-select
      style="width: 200px"
      v-model="value"
      @change="changeFile"
      placeholder="请选择"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <div class="iframe-box">
      <iframe
        name="myiframe"
        id="ocx2"
        :src="url"
        frameborder="0"
        align="middle"
        width="100%"
        height="100%"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      options: [],
      url:''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getUrl(id) {
      let url = "";
      this.options.forEach((el) => {
        if (el.id == id) {
          url = el.url;
        }
      });
      return url;
    },
    async getList() {
      try {
        const res = await this.$api.tenderFileList(this.$route.query.bdId);
        this.options = res.data;
        this.value = this.$route.query.id;
        this.url = this.getUrl(this.value)
      } catch (error) {
        console.log(error);
      }
    },
    changeFile(value) {
      this.url = this.getUrl(value)
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.iframe-box {
  margin-top: 8px;
  flex: 1;
}
</style>